const initialState = {
  token: ''
}

export default initialState